import { toast } from "react-toastify";
import { setTagList, selCurentTag, setFlightTag, setUserTag } from "./tagSlice";
// import * as R from "ramda";
import loaderClient from "api/reduxLoaderApi";
import { selAirlineId } from "store/slices";

export const getUserTags = () => async (dispatch, getState) => {
  let airlineId = selAirlineId(getState());
  const client = loaderClient("get")(
    `/tags?airline=${airlineId}&category=user&limit=1000`
  );
  const res = await client({})({});
  if (!res.message || res.error) return "";
  return dispatch(setUserTag(res.message));
};

export const getFlightTags = () => async (dispatch, getState) => {
  let airlineId = selAirlineId(getState());
  const client = loaderClient("get")(
    `/tags?airline=${airlineId}&category=flight&limit=1000`
  );
  const res = await client({})({});
  if (!res.message) return "";
  return dispatch(setFlightTag(res.message));
};

export const createTag = (data, callback) => async (dispatch) => {
  const client = loaderClient("post")("/tags");
  const res = await client(data)({});
  return callback && callback(res.error, res.message || "");
};

export const editTag =
  (data, callback = false) =>
  async (dispatch, getState) => {
    const tag = selCurentTag(getState());
    const client = loaderClient("patch")(`/tags/${tag.id}`);
    const res = await client(data)({});
    return callback && callback(res.error, res.message || "");
  };

export const deleteTags =
  (id, callback = false) =>
  async (dispatch) => {
    const client = loaderClient("delete")(`/tags/${id}`);
    const res = await client({})({});
    return callback && callback(res.error, res.message || "");
  };
